import { render, staticRenderFns } from "./UserAdministrationDetailRoles.vue?vue&type=template&id=5bb64013&scoped=true&"
import script from "./UserAdministrationDetailRoles.vue?vue&type=script&lang=ts&"
export * from "./UserAdministrationDetailRoles.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdministrationDetailRoles.vue?vue&type=style&index=0&id=5bb64013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb64013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCardText,VIcon,VSelect})
